import {HeadingAreaMessageParams} from './HeadingAreaMessageComponent'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import EventEmitterEx from './EventEmitterEx'
import {DialogParams} from './DialogComponent'
import {HttpError} from '../../../network/errors/HttpError'
import {HttpTimeoutError} from '../../../network/errors/baseHandling/HttpTimeoutError'

export default class EventEmitterExAdmin extends EventEmitterEx {
    clearHeadingAreaMessage(): void {
        this.emit('clearHeadingAreaMessage')
    }

    async showDialog(params: DialogParams): Promise<void> {
        await this.waitNextEventLoop()
        this.emit('showDialog', params)
    }

    closeDialog(): void {
        this.emit('closeDialog')
    }

    async broadcastErrors(error: HttpError | HttpTimeoutError): Promise<void> {
        await this.waitNextEventLoop()
        await error.broadcast(this)
    }

    clearBroadcastedErrors(): void {
        this.clearHeadingAreaMessage()
        this.emit('clearAllErrors')
    }

    scrollToContentsTop(): void {
        this.emit('scrollToContentsTop')
    }
}
